import { FilePond, registerPlugin } from "react-filepond";
import React from "react";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImageCrop from "filepond-plugin-image-crop";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";

registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginImageCrop,
  FilePondPluginFileValidateType
);

type Props = {
  className?: string;
  name: string;
  defaultValue?: string;
  multiple?: boolean;
  server?: string;
  maxFiles?: number;
  onSelectImage: (image: File | null) => void;
};

const InputFile: React.FC<Props> = ({
  className,
  defaultValue,
  name,
  multiple,
  server,
  maxFiles,
  onSelectImage,
}) => {
  const handleUpdateFiles = (fileItems: any) => {
    if (fileItems.length > 0) {
      const file = fileItems[0].file;
      onSelectImage(file);
    } else {
      onSelectImage(null);
    }
  };

  return (
    <div className={className}>
      <FilePond
        allowMultiple={multiple}
        maxFiles={maxFiles ?? 5}
        allowReorder={true}
        allowImageCrop={true}
        server={server}
        onupdatefiles={handleUpdateFiles}
        labelIdle="Arraste e solte o seu arquivo ou <span >Clique aqui</span>"
      />
    </div>
  );
};

export { InputFile };
